module.exports = __webpack_public_path__ + "media/customizations/colton/logo-new-4df13765081bfbcb1b97ff19fe2d31d6.png";